import { useNavigate } from 'react-router';
import { GlobalSearchBar as SharedGlobalSearchBar } from '@moko/ui';
import type { IGlobalSearchItem } from '@moko/ui';
import { getGlobalSearch } from '../services/globalSearchService';

const routeMap: Record<string, string> = {
  works: '/editWork',
  orders: '/editOrder',
  assets: '/editAsset',
};

const GlobalSearchBar = () => {
  const navigate = useNavigate();

  const handleResultClick = (item: IGlobalSearchItem) => {
    const base = routeMap[item.type] ?? '/';
    navigate(`${base}?id=${item.id}`);
  };

  return (
    <SharedGlobalSearchBar
      searchFn={getGlobalSearch}
      onResultClick={handleResultClick}
    />
  );
};

export default GlobalSearchBar;
